import { Bot, MessageSquare, Zap, MessagesSquare } from 'lucide-react'
import MetricCard from '../components/MetricCard'
import GlassCard from '../components/GlassCard'
import Skeleton from '../components/Skeleton'

function MetricCardSkeleton() {
  return (
    <GlassCard className="p-5">
      <div className="flex items-center gap-2.5">
        <Skeleton className="h-8 w-8 !rounded-xl" />
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-2 w-14" />
        </div>
      </div>
      <div className="mt-4">
        <Skeleton className="h-8 w-24" />
      </div>
      <div className="mt-4 flex flex-col gap-2">
        <Skeleton className="h-1.5 w-full !rounded-full" />
        <Skeleton className="h-2.5 w-16" />
      </div>
    </GlassCard>
  )
}

export default function PlanLimitsGrid({ home, loading, onUpgrade }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <MetricCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  const items = [
    {
      icon: Bot,
      label: 'Assistentes',
      value: home?.assistants?.value,
      max: home?.assistants?.max,
    },
    {
      icon: MessageSquare,
      label: 'Mensagens',
      value: home?.messages?.value,
      max: home?.messages?.max,
    },
    {
      icon: Zap,
      label: 'Interações',
      info: 'Gatilhos executados',
      value: home?.interactions?.value,
      max: home?.interactions?.max,
    },
    {
      icon: MessagesSquare,
      label: 'Conversas',
      value: home?.conversations?.value,
      max: home?.conversations?.max,
    },
  ]

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {items.map((item) => (
        <MetricCard
          key={item.label}
          icon={item.icon}
          label={item.label}
          info={item.info}
          value={item.value}
          max={item.max}
          onUpgrade={onUpgrade}
        />
      ))}
    </div>
  )
}
